import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {HISTORY_KEY_VIEW_DIALECT, SearchParam} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, DIALECT_IN_API_URL} from '../../defines/protocol';
import {ListLoader} from '../../interfaces/list-loader';
import {SearchHistory} from '../../models/history.model';
import {SimpleDialect} from '../../models/dialect.model';
import {ApiService} from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class DialectHistoryService implements ListLoader<SimpleDialect> {

  private history: SearchHistory;

  private listDialect: Array<SimpleDialect> | null = null;
  private mapDialect: Map<string, SimpleDialect> | null = null;
  private load$: Observable<boolean> | null = null;

  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_VIEW_DIALECT});
  }

  public addHistory(id: string): void {
    if (!id) {
      console.error('DialectHistoryService::addHistory() invalid id', id);
    }
    else {
      this.history.addItem(id);
    }
  }

  /******************************************************************************
   * ListLoader<SimpleProverb> 구현부
   *****************************************************************************/

  // TODO: 일단 페이지 없이 모두 로딩한다. 나중에 페이지 로딩 추가해야 함.
  // private nextPage: number;

  public getList(): Array<SimpleDialect> | null {
    return this.listDialect;
  }

  public getCurCount(): number | null {
    console.log('DialectHistoryService::getCurCount()');
    return this.listDialect?.length ?? null;
  }

  public getTotalCount(): number {
    // console.log('DialectHistoryService::getTotalCount()');
    return (this.history && this.history.list && this.history.size) ?? 0;
  }

  public IsComplete(): boolean {
    // console.log('DialectHistoryService::IsComplete()');
    return this.history && (
      this.listDialect?.length === this.history.size ||
      this.history.empty()
    );
  }

  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getById(id: string): SimpleDialect | null {
    return this.mapDialect?.get(id) ?? null;
  }

  public ResetList(param?: SearchParam): void {
    // console.log('DialectHistoryService::ResetList()', param, this);
    this.listDialect = null;
    this.mapDialect = null;

    // this.nextPage = 0;
    if (param?.id) {
      this.addHistory(param.id);
    }
  }

  public GetNextList(): Observable<boolean> {
    console.log('DialectHistoryService::GetNextList()', this);
    // 이미 다 로딩 했는지 확인
    // if (this.history.listHistory.length < this.nextPage * HISTORY_PAGE_SIZE) {
    if (this.IsComplete()) {
      return throwError({message: 'already load all proverbs in bookmark'});
    }
    else if (this.history.empty()) {
      // 이력이 없으면 서버에 요청하지 않고 처리한다.
      return new Observable<boolean>(observer => {
        observer.next(false);
        observer.complete();
      }).pipe(delay(0));
    }

    if (this.load$) {
      return this.load$;
    }

    const url = DIALECT_IN_API_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        // if (this.nextPage === 0) {
        this.listDialect = new Array<SimpleDialect>();
        this.mapDialect = new Map<string, SimpleDialect>();
        // }
        data.forEach(value => {
          if (this.listDialect === null) {
            throw new Error("DialectHistory::GetNextList() listDialect is null");
          }
          if (this.mapDialect === null) {
            throw new Error("DialectHistory::GetNextList() mapDialect is null");
          }

          const dialect = new SimpleDialect(value);
          this.listDialect.push(dialect);
          this.mapDialect.set(dialect.id, dialect);
        });

        if (this.listDialect.length !== this.history.size) {
          console.error('DialectHistoryService::GetNextList() invalid received list length', this.listDialect, this.history.list);
        }

        // return this.nextPage++ === 0;
        return true;
      })
    );
  }
}
